import { Box, styled } from "@mui/system"
import { Typography } from "@mui/material"


export const Wrapper = styled(Box)`
  background-color: var(--white);
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  padding: 32px;
  gap: 16px;
`;
export const SectionTitle = styled(Typography)`
    font-size: 1rem;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
`;
export const SecondarySectionTitle = styled(Typography)`
    font-size: 12px;
    font-weight: 600;
    color: #333;
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const FormHeading = styled(Typography)`
  font-size: 24px;
  font-weight: 700;
  color: #111;
`
export const FormSubHeading = styled(Typography)`
  font-size: 0.9rem;
  font-weight: 400;
  color: #5BC0EB;
  margin-top: 0.5;
`  